import React, {Fragment,useState,useRef} from 'react';
import { useEffect } from 'react';
import {
    Table,Col, Row, Card, CardBody,
    CardTitle, Button, Form, FormGroup, Label, Input,Modal
} from 'reactstrap';
import Parametri from '../../parametri';

import Clessidra from '../Clessidra.js';
import Modale from '../Modale.js';

import Interrogativo from '../../immagini/interrogativo-azzurro.png';
import FinestraDialogo from '../FinestraDialogo.js';

import TrasformaDateAUmano from '../TrasformaDateAUmano.js';
import FormattaImportoVideo from '../FormattaImportoVideo.js';

import * as XLSX from 'xlsx';//richiede npm i --save xlsx --force

import TabellaPrimaNota  from '../TabellaPrimaNota/Tabella.js';

const STATO_INDEFINITO = 0;
const STATO_INSERISCI = 1;
const STATO_MEMORIZZAZIONE = 2;//utilizzato per eseguire le operazioni di inserimento/modifica/eliminazione record
const STATO_ERRORE_CONNESSIONE = 3;
const STATO_OPERAZIONE_FALLITA = 4;
const STATO_RICERCA_DATI = 5;//utilizzato nel caso modifica e cancella quando vado a ricercare i dati per popolare i campi della scheda
const STATO_RICERCA_DATI_CORRETTA = 6;//utilizzato a valle della ricerca dati record in caso di modifica o cancellazione di un record
const STATO_PRESENTA_REPORT = 7;

function FormGridFormRow(props) {
    
    const [operazione,setOperazione] = useState('');
    const [variazioneCampi,setVariazioneCampi]=useState(0);

    const [statoPagina,setStatoPagina]=useState(STATO_INDEFINITO);
    const [error,setError]=useState('');
    const [periodicita, setPeriodicita] = useState("1");
    const [periodi, setPeriodi] = useState([]);
    const [dataFinePeriodo, setDataFinePeriodo] = useState("");

    const [inizioPeriodo, setInizioPeriodo] = useState("");
    const [finePeriodo, setFinePeriodo] = useState("");

    const [disabilitaBottoni,setDisabilitaBottoni]= useState(false);
    const [loading,setLoading]= useState(false);

    const [risultatoServer,setRisultatoServer]=useState('');

    const [flagAttesaGenerazioneFile, setFlagAttesaGenerazioneFile] = useState(false);

    useEffect(() => {   
        //devo eseguire una fetch per popolare i valori attualmente memorizzati:
        // parametri per inviare i dati al server:
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"impostaEstrazionePrimaNotaRecuperaDati",
                id:props.id,
                emak: props.emak,
                sessionId:props.sessionId
            })
        };
        setLoading(true);

        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
        .then(risposta => risposta.json())
        .then(
            (valoreDiRitorno) => {
                 setLoading(false);
                if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                    alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
                }
                if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                if(valoreDiRitorno.risultatoOperazione===1){
                    //setRisultatoServer(valoreDiRitorno.risultatoRitorno);
                    setPeriodicita(valoreDiRitorno.risultatoRitorno[0].PERIODICITA_PRIMA_NOTA);
                    setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
                }
            },
            (error) => {setLoading(false);setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
        ); 
    },[]);

    useEffect(() => {
        if (flagAttesaGenerazioneFile) {
          estraiExcel();
        }
      }, [flagAttesaGenerazioneFile])

      useEffect(() => {
        const nuoviPeriodi = generaPeriodi(parseInt(periodicita));
        setPeriodi(nuoviPeriodi);
    
        if (nuoviPeriodi.length > 1) {
            // Se ci sono almeno due periodi, scegli il secondo come default (il mese precedente)
            const selezionato = nuoviPeriodi[1];
            setDataFinePeriodo(selezionato.value);
            setInizioPeriodo(selezionato.inizio);
            setFinePeriodo(selezionato.value);
        } else if (nuoviPeriodi.length > 0) {
            // Se c'è solo un periodo, usa il primo
            const selezionato = nuoviPeriodi[0];
            setDataFinePeriodo(selezionato.value);
            setInizioPeriodo(selezionato.inizio);
            setFinePeriodo(selezionato.value);
        }
    }, [periodicita]);
    

    function tornaElenco() {
        props.callbackTermineModifica();
    }
    /*function tornaScheda() {
        setFineSpazio(0);
    }*/
        function generaPeriodi(periodicita) {

    let quanti = 0;
    const periodi = [];
    const oggi = new Date();
    const meseCorrente = oggi.getMonth(); // 0-based (0 = gennaio)
    const annoCorrente = oggi.getFullYear();

    // per avere sempre e comunque la possibilità di fare report nei 5 anni precedenti
    if (periodicita == 1) quanti = 60;
    if (periodicita == 2) quanti = 30;
    if (periodicita == 3) quanti = 20;
    if (periodicita == 6) quanti = 10;
    if (periodicita == 12) quanti = 5;

    const bloccoCorrente = Math.floor(meseCorrente / periodicita); // blocco corrente (0-based)
    let ultimoBlocco = bloccoCorrente - 1;
    let annoBlocco = annoCorrente;

    // Se siamo nel primo blocco dell'anno, andiamo all'anno precedente
    if (ultimoBlocco < 0) {
        ultimoBlocco = Math.floor(12 / periodicita) - 1;
        annoBlocco--;
    }

    // Funzione per formattare la data
    const formatDate = (date) => {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };

    // === AGGIUNGIAMO IL PERIODO IN CORSO ===
    {
        const meseInizio = bloccoCorrente * periodicita;
        const meseFine = meseInizio + periodicita - 1;
        const anno = annoCorrente;

        const inizioPeriodo = new Date(anno, meseInizio, 1);
        const finePeriodo = new Date(anno, meseFine + 1, 0); // Ultimo giorno del mese fine

        let label = "";
        if (periodicita === 1) {
            label = finePeriodo.toLocaleString('default', { month: 'long', year: 'numeric' });
        } else if (periodicita === 12) {
            label = `${anno}`;
        } else {
            const tipo = periodicita === 2 ? "Bimestre" :
                         periodicita === 3 ? "Trimestre" :
                         periodicita === 6 ? "Semestre" : "Periodo";
            const meseInizioStr = String(meseInizio + 1).padStart(2, '0');
            const meseFineStr = String(meseFine + 1).padStart(2, '0');
            label = `${tipo} ${meseInizioStr}/${anno} - ${meseFineStr}/${anno}`;
        }

        const value = formatDate(finePeriodo);
        const inizio = formatDate(inizioPeriodo);
        periodi.unshift({ label, value, inizio });
    }

    // === AGGIUNGIAMO I PERIODI CONCLUSI ===
    for (let i = 0; i < quanti; i++) {
        const blocchiPerAnno = Math.floor(12 / periodicita);
        const bloccoIndex = ultimoBlocco - i;

        const anniIndietro = Math.floor(bloccoIndex / blocchiPerAnno);
        const bloccoOffset = ((bloccoIndex % blocchiPerAnno) + blocchiPerAnno) % blocchiPerAnno;
        const anno = annoBlocco + anniIndietro;
        const meseInizio = bloccoOffset * periodicita;
        const meseFine = meseInizio + periodicita - 1;

        const inizioPeriodo = new Date(anno, meseInizio, 1);
        const finePeriodo = new Date(anno, meseFine + 1, 0);

        let label = "";
        if (periodicita === 1) {
            label = finePeriodo.toLocaleString('default', { month: 'long', year: 'numeric' });
        } else if (periodicita === 12) {
            label = `${anno}`;
        } else {
            const tipo = periodicita === 2 ? "Bimestre" :
                         periodicita === 3 ? "Trimestre" :
                         periodicita === 6 ? "Semestre" : "Periodo";
            const meseInizioStr = String(meseInizio + 1).padStart(2, '0');
            const meseFineStr = String(meseFine + 1).padStart(2, '0');
            label = `${tipo} ${meseInizioStr}/${anno} - ${meseFineStr}/${anno}`;
        }

        const value = formatDate(finePeriodo);
        const inizio = formatDate(inizioPeriodo);
        periodi.push({ label, value, inizio });
    }

    return periodi;
}


    function scaricaXLSX(){
        //compongo gli array a seconda delle colonne che dovrò vedere:
     
        //ora faccio la fetch per estrarre i dati

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"impostaEstrazionePrimaNotaEstraiDatiXLSX",
                periodicita:periodicita,
                dataInizio:inizioPeriodo,
                dataFine:finePeriodo,
                emak: props.emak,sessionId:props.sessionId})
          };
      
          fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
              (valoreDiRitorno) => {
                if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                  alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
                }
                if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                if(valoreDiRitorno.risultatoOperazione===1){
                  setRisultatoServer(valoreDiRitorno.risultatoRitorno);
                  //setInizioPeriodo(valoreDiRitorno.periodo[0].DATA_INIZIO_PERIODO);            
                  //setFinePeriodo(valoreDiRitorno.periodo[0].DATA_FINE_PERIODO);
                    //setStatoPagina(STATO_PRESENTA_REPORT);
                    setFlagAttesaGenerazioneFile(true);
                  //estraiExcelPDF();
                }
                  
              },
            (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
            );

        //terminata la fetch posso far vedere i risulrati chiamando la funzione async presente in tabellaricerca.js:
        
    }


    async function estraiExcel() {
      const nomeFile = (new Date().toISOString().split('T')[0]) +
        (props.titolo ? ` ${props.titolo}` : " PrimaNota") + ".xlsx";
    
      await new Promise(resolve => setTimeout(resolve, 500));
    
      const tutteLeRisorseSet = new Set();
      const aggiungiRisorse = (array, campo) => array?.forEach(r => r[campo] && tutteLeRisorseSet.add(r[campo]));
      aggiungiRisorse(risultatoServer.liquiditaInizioAnno, "RISORSA_INIZIO_ANNO");
      aggiungiRisorse(risultatoServer.liquiditaFineAnno, "RISORSA_FINE_ANNO");
      aggiungiRisorse(risultatoServer.movimentiPagatiPeriodo, "RISORSA_P");
      aggiungiRisorse(risultatoServer.movimentiModificatiPeriodo, "RISORSA_M");
    
      const risorseOrdinate = Array.from(tutteLeRisorseSet);
    
      const creaHeaderDueRighe = () => {
        const header1 = ["", "", "", "", "", ""];
        const header2 = ["", "Descrizione", "Data Pagamento", "Voce di Bilancio", "Attività principale", "Data Variazione"];
        risorseOrdinate.forEach(ris => {
          header1.push(ris, "");
          header2.push("Importo Totale Lordo", "IVA");
        });
        return { header1, header2 };
      };
    
      const datiFoglio = [];
    
      const creaRigheDaMovimenti = (movimenti, campoRisorsa, campoSaldo, campoIVA, campoVoce, campoDataPagamento, campoAttivita, campoDataVariazione, campoDescrizione) => {
        const righe = [];
        movimenti?.forEach(mov => {
          const attivitaVal = parseInt(mov[campoAttivita]);
          const attivita = attivitaVal === 1 ? "Sì" : attivitaVal === 0 ? "No" : "";
          const descrizione = mov[campoDescrizione] || "";
    
          const riga = [
            "",
            descrizione,
            mov[campoDataPagamento] ? TrasformaDateAUmano({ data: mov[campoDataPagamento] }) : "",
            mov[campoVoce] || "",
            attivita,
            mov[campoDataVariazione] ? TrasformaDateAUmano({ data: mov[campoDataVariazione] }) : ""
          ];
    
          risorseOrdinate.forEach(ris => {
            if (mov[campoRisorsa] === ris) {
              riga.push(FormattaImportoVideo(mov[campoSaldo] || "0,00"), FormattaImportoVideo(mov[campoIVA] || "0,00"));
            } else {
              riga.push("0,00", "0,00");
            }
          });
    
          righe.push(riga);
        });
        return righe;
      };
    
     
    
      if (risultatoServer.movimentiModificatiPeriodo && risultatoServer.movimentiModificatiPeriodo.length > 0) {
        datiFoglio.push([{ v: `Movimenti Modificati dal ${TrasformaDateAUmano({ data: inizioPeriodo })} al ${TrasformaDateAUmano({ data: finePeriodo })} relativi a periodi precedenti`, s: { font: { bold: true } } }]);
        const { header1, header2 } = creaHeaderDueRighe();
        datiFoglio.push(header1);
        datiFoglio.push(header2);
    
        const righeModificati = creaRigheDaMovimenti(
          risultatoServer.movimentiModificatiPeriodo,
          "RISORSA_M", "SALDO_M", "IVA_M", "VOCE_M", "DATA_PAGAMENTO_M", "ATTIVITA_M", "DATA_VARIAZIONE_M", "DESCRIZIONE_M"
        );
        datiFoglio.push(...righeModificati);
    
        const totali = Array(6).fill("");
        for (let i = 0; i < risorseOrdinate.length; i++) {
          totali.push("0,00", "0,00");
        }
    
        righeModificati.forEach(riga => {
          for (let i = 6; i < riga.length; i++) {
            const val = parseFloat(riga[i]?.toString().replace(",", ".")) || 0;
            const somma = (parseFloat(totali[i].replace(",", ".")) + val).toFixed(2);
            totali[i] = FormattaImportoVideo(somma);
          }
        });
    
        totali[0] = "Totale";
        datiFoglio.push(totali);
    
        datiFoglio.push([], []);
      }
    
      datiFoglio.push([{ v: `Movimenti Eseguiti nel periodo dal ${TrasformaDateAUmano({ data: inizioPeriodo })} al ${TrasformaDateAUmano({ data: finePeriodo })}`, s: { font: { bold: true } } }]);
      const { header1: header1Eseguiti, header2: header2Eseguiti } = creaHeaderDueRighe();
      datiFoglio.push(header1Eseguiti);
      datiFoglio.push(header2Eseguiti);
    
      const rigaInizio = Array(6).fill("");
      rigaInizio[0] = "Liquidità inizio periodo";
      const mappaInizio = new Map();
      risultatoServer.liquiditaInizioAnno?.forEach(r => {
        if (r["RISORSA_INIZIO_ANNO"]) {
          mappaInizio.set(r["RISORSA_INIZIO_ANNO"], {
            Saldo: r["SALDO_INIZIO_ANNO"] || "0,00",
            IVA: r["IVA_INIZIO_ANNO"] || "0,00"
          });
        }
      });
      risorseOrdinate.forEach(ris => {
        const val = mappaInizio.get(ris) || {};
        rigaInizio.push(FormattaImportoVideo(val.Saldo || "0,00"), FormattaImportoVideo(val.IVA || "0,00"));
      });
      datiFoglio.push(rigaInizio);
    
      const righePagati = creaRigheDaMovimenti(
        risultatoServer.movimentiPagatiPeriodo,
        "RISORSA_P", "SALDO_P", "IVA_P", "VOCE_P", "DATA_PAGAMENTO_P", "ATTIVITA_P", "DATA_VARIAZIONE_P", "DESCRIZIONE_P"
      );
      datiFoglio.push(...righePagati);
    
      const rigaFine = Array(6).fill("");
      rigaFine[0] = "Liquidità fine periodo";
      const mappaFine = new Map();
      risultatoServer.liquiditaFineAnno?.forEach(r => {
        if (r["RISORSA_FINE_ANNO"]) {
          mappaFine.set(r["RISORSA_FINE_ANNO"], {
            Saldo: r["SALDO_FINE_ANNO"] || "0,00",
            IVA: r["IVA_FINE_ANNO"] || "0,00"
          });
        }
      });
      risorseOrdinate.forEach(ris => {
        const val = mappaFine.get(ris) || {};
        rigaFine.push(FormattaImportoVideo(val.Saldo || "0,00"), FormattaImportoVideo(val.IVA || "0,00"));
      });
      datiFoglio.push(rigaFine);
    
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(datiFoglio);
    
      ws['!merges'] = [];
      const addMergeRigaRisorse = (rowIndex) => {
        risorseOrdinate.forEach((_, idx) => {
          const colStart = 6 + idx * 2;
          ws['!merges'].push({
            s: { r: rowIndex, c: colStart },
            e: { r: rowIndex, c: colStart + 1 }
          });
    
          const cellKey = XLSX.utils.encode_cell({ r: rowIndex, c: colStart });
          if (!ws[cellKey]) ws[cellKey] = { t: "s", v: risorseOrdinate[idx] };
          ws[cellKey].s = {
            alignment: { horizontal: "center" },
            font: { bold: true }
          };
        });
      };
    
      const rowModificati = datiFoglio.findIndex(r => r?.[0]?.v?.startsWith("Movimenti Modificati"));
      const rowEseguiti = datiFoglio.findIndex(r => r?.[0]?.v?.startsWith("Movimenti Eseguiti"));
      if (rowModificati > -1) addMergeRigaRisorse(rowModificati + 1);
      if (rowEseguiti > -1) addMergeRigaRisorse(rowEseguiti + 1);
    
      XLSX.utils.book_append_sheet(wb, ws, "Liquidità Dettaglio");
      XLSX.writeFile(wb, nomeFile);
      setStatoPagina(STATO_PRESENTA_REPORT);
      setFlagAttesaGenerazioneFile(false);
    }
    

   
    //JSON.stringify(risultatoServer)
        return (
            <Fragment>
              {flagAttesaGenerazioneFile ?
                <div style={{color:"#FFFFFF", backgroundColor:"#008055", margin:20, padding:10, border: "1px solid black"}}>
                <span style={{fontSize:20}}>GENERAZIONE DEL FILE RICHIESTO</span>
                <br />
                POSSONO ESSERE NECESSARI ALCUNI MINUTI, ATTENDERE
                <span style={{
                  animation: 'lampeggiaPuntini 1s infinite',
                  fontWeight: 'bold'
                }}>
                  ...
                </span>
              </div>
                :
                <>
   
                {/*eccola {props.sessionId}*/}
               
                {statoPagina === STATO_PRESENTA_REPORT ? 
                  <TabellaPrimaNota {...props} />
                 :""}

                {statoPagina === STATO_MEMORIZZAZIONE ? <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>
                <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}><Clessidra loading={true}/>
                </div>
                </div> :""}
                {statoPagina === STATO_ERRORE_CONNESSIONE ? <div>Errore: 1ImpPriN {error.message}</div> :""}
                {statoPagina === STATO_OPERAZIONE_FALLITA ? <div>Errore per operazione errata</div> :""}
                {statoPagina === STATO_RICERCA_DATI ? <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>
                <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}><Clessidra loading={true}/>
                </div>
                </div> :""}

                {statoPagina === STATO_RICERCA_DATI_CORRETTA ?
                
                <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>

                    <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}>
                        <CardTitle>Impostazioni Estrazione Prima Nota</CardTitle>
                        <Clessidra loading={loading}/>
                            <>
                                <div style={{paddingLeft:10}}> {/* impostazioni*/}
                                    <Row form style={{marginTop:20}}>
                                    <Col md={12}>
                                        <Label for="per">Tipologia di estrazione della prima nota</Label>
                                    </Col>
                                    <Col md={6}>
                                        <Row form style={{marginLeft:20,marginRight:20}}>
                                            <Col md={12}><Label><Input type="radio" name="periodicita" value="1" checked={periodicita === "1"} onChange={(e)=>{setPeriodicita(e.target.value);}}/> {' Mese'}</Label></Col>
                                        </Row>  
                                        <Row form style={{marginLeft:20,marginRight:20}}>  
                                            <Col md={12}><Label><Input type="radio" name="periodicita" value="2" checked={periodicita === "2"} onChange={(e)=>{setPeriodicita(e.target.value);}}/> {' Bimestre'}</Label></Col>
                                        </Row>
                                        <Row form style={{marginLeft:20,marginRight:20}}>    
                                            <Col md={12}><Label><Input type="radio" name="periodicita" value="3" checked={periodicita === "3"} onChange={(e)=>{setPeriodicita(e.target.value);}}/> {' Trimestre'}</Label></Col>
                                        </Row>
                                        <Row form style={{marginLeft:20,marginRight:20}}>   
                                            <Col md={12}><Label><Input type="radio" name="periodicita" value="6" checked={periodicita === "6"} onChange={(e)=>{setPeriodicita(e.target.value);}}/> {' Semestre'}</Label></Col>
                                        </Row>
                                        <Row form style={{marginLeft:20,marginRight:20}}>   
                                            <Col md={12}><Label><Input type="radio" name="periodicita" value="12" checked={periodicita === "12"} onChange={(e)=>{setPeriodicita(e.target.value);}}/> {' Anno'}</Label></Col>
                                        </Row>
                                    </Col>
                                    <Col md={6}>
                                    {/*tendina popolata con: 
                                    se il primo radio è 1 -> mesi in ordine descrescente a partire dall'attuale
                                    se il primo radio è 2 -> bimestri in ordine descrescente a partire dall'attuale
                                    se il primo radio è 3 -> trimestri in ordine descrescente a partire dall'attuale
                                    se il primo radio è 6 -> semestri in ordine descrescente a partire dall'attuale
                                    se il primo radio è 12 -> anni in ordine descrescente a partire dall'attuale
                                    */}
                                    <Input 
                                        type="select" 
                                        id="dataFinePeriodo" 
                                        value={dataFinePeriodo}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setDataFinePeriodo(value);
                                            const selezionato = periodi.find(p => p.value === value);
                                            if (selezionato) {
                                                setInizioPeriodo(selezionato.inizio);
                                                setFinePeriodo(selezionato.value);
                                            }
                                        }}
                                    >
                                        {periodi.map((p, idx) => (
                                            <option key={idx} value={p.value}>
                                                {p.label}
                                            </option>
                                        ))}
                                    </Input>
                                    <div style={{marginTop:10}}>
                                    Data inizio: <TrasformaDateAUmano data={inizioPeriodo}></TrasformaDateAUmano>
                                    </div>
                                    <div style={{marginTop:10}}>
                                    Data fine: <TrasformaDateAUmano data={finePeriodo}></TrasformaDateAUmano>
                                    </div>
                                    </Col>
                                    </Row>
                                </div>  
                                
                            </>         
                     </div>

                    <div className="schedaSpazioInferiore">
           
                   
                                    <Button disabled={disabilitaBottoni} className="mt-2 bottoneMargineADestra" color="success" onClick={() => {{                    
                                            scaricaXLSX();
                                        }}
                                    }>
                                    Scarica XSLX
                                    </Button>
                               



                    <Button disabled={disabilitaBottoni} color="primary" className="mt-2" onClick={() => setStatoPagina(STATO_PRESENTA_REPORT)} >
                    <Fragment> Annulla </Fragment>
                    </Button>
                    </div>       
                </div>
                :""}
                </>
              }  
            </Fragment>
        );
}
export default FormGridFormRow;
